import type { AxiosInstance } from 'axios';

import type { Plan, PlanCreateInput, PlanUpdateInput } from '@domain/plan/Plan';
import type { PlanRepository } from '@domain/plan/PlanRepository';
import type { ListPage, ListParams } from '@domain/customer/CustomerRepository';

import { ADMIN_API_BASE } from './client';

export class HttpPlanRepository implements PlanRepository {
  constructor(private readonly api: AxiosInstance) {}

  async list(params: ListParams): Promise<ListPage<Plan>> {
    const query: Record<string, string | number> = { limit: params.limit };
    if (params.offset !== undefined) query.offset = params.offset;
    const r = await this.api.get(`${ADMIN_API_BASE}/plans/`, { params: query });
    return r.data as ListPage<Plan>;
  }

  async create(input: PlanCreateInput): Promise<Plan> {
    const r = await this.api.post(`${ADMIN_API_BASE}/plans/`, input);
    return r.data as Plan;
  }

  async update(id: string, input: PlanUpdateInput): Promise<Plan> {
    const r = await this.api.patch(`${ADMIN_API_BASE}/plans/${id}/`, input);
    return r.data as Plan;
  }

  async deactivate(id: string): Promise<Plan> {
    const r = await this.api.post(`${ADMIN_API_BASE}/plans/${id}/deactivate/`);
    return r.data as Plan;
  }

  async reactivate(id: string): Promise<Plan> {
    const r = await this.api.post(`${ADMIN_API_BASE}/plans/${id}/reactivate/`);
    return r.data as Plan;
  }
}
